import {StageProvider} from '@pinecast/common/Stage';
import {GQLProvider} from '@pinecast/gql';
import {Provider as I18nProvider} from '@pinecast/i18n';
import {DarkModeProvider} from '@pinecast/styles';
import {Provider as StyletronProvider} from '@pinecast/styles/provider';
import * as React from 'react';
import {createRoot} from 'react-dom/client';

import type {Mountable} from './types';

export default function mount(node: React.ReactNode, elem: HTMLElement) {
  const root = createRoot(elem);
  root.render(
    <React.StrictMode>
      <I18nProvider>
        <StyletronProvider>
          <DarkModeProvider>
            <GQLProvider>
              <StageProvider>{node}</StageProvider>
            </GQLProvider>
          </DarkModeProvider>
        </StyletronProvider>
      </I18nProvider>
    </React.StrictMode>,
  );
}

export function applyProps(
  component: Mountable<Record<string, any>>,
  elem: HTMLElement,
) {
  return React.createElement(
    component,
    Object.keys(component.propExtraction).reduce(
      (acc, cur) => {
        acc[cur] = component.propExtraction[cur](elem);
        return acc;
      },
      {} as {[key: string]: any},
    ),
  );
}
